import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'share-buttons',
	inputs: ['url', 'title'],
	templateUrl: './share-buttons.component.html',
	styleUrls: ['./share-buttons.component.css']
})
export class ShareButtonsComponent implements OnInit {
	title: string;
	url: string;
	shareLinks: ShareLink[];
	constructor() {
	}

	ngOnInit() {
		this.shareLinks = [];
		this.shareLinks.push(new ShareLink("Facebook", this.getUrl("https://www.facebook.com/sharer.php?", "t", "u"), "#4E67AF", "fa-facebook"));
		this.shareLinks.push(new ShareLink("Linked In", this.getUrl("https://www.linkedin.com/shareArticle?", "title", "url"),"#376DA4", "fa-linkedin"));
		this.shareLinks.push(new ShareLink("Twitter", this.getUrl("https://twitter.com/intent/tweet?", "text", "url"),"#58A9EB","fa-twitter"));
		this.shareLinks.push(new ShareLink("Whatsapp", this.getUrl("https://web.whatsapp.com/send?", "", "text"),"#6ECE6D","fa-whatsapp"));
		this.shareLinks.push(new ShareLink("Pinterest", this.getUrl("https://pinterest.com/pin/create/button/?", "description", "url"),"#A92D23","fa-pinterest-p"));;
	}

	getUrl(link, keyTitle, keyUrl) {
		var url = new URL(link);

		if (keyTitle != undefined && keyTitle !== "") {
			url.searchParams.set(keyTitle, this.title);
		}

		if (keyUrl != undefined && keyUrl !== "") {
			url.searchParams.set(keyUrl, this.url);
		}

		return url.toString();
	}

	redirect(shareLink: ShareLink) {
		console.log(shareLink.url);
		window.open(shareLink.url);
	}
}

export class ShareLink {
	name: string;
	url: string;
	color: string;
	icon: string;

	constructor(name: string, url: string, color: string, icon: string) {
		this.name = name;
		this.url = url;
		this.color = color;
		this.icon = icon;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/utility/share-buttons/share-buttons.component.ts